import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale } from '@components/frame';
import Icon from '@styles/icons/svg';
import { font } from '@styles/fonts';
import { TRACEABILITY_GRAPH_NODE_CONFIG } from '@v2/pages/common/components/TraceabilityGraph/constants';
import { TraceabilityGraphProps, TraceabilityNode, TraceabilityNodeType } from '@v2/pages/common/components/TraceabilityGraph/types';

export const NodeCardContent: FC<Pick<TraceabilityGraphProps, 'C'> & { node: TraceabilityNode }> = ({ C, node }) => {
  const config = TRACEABILITY_GRAPH_NODE_CONFIG[node.type] ?? TRACEABILITY_GRAPH_NODE_CONFIG[TraceabilityNodeType.SUMMARY];

  return (
    <>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(8) }}>
        <View
          style={{
            width: scale(28),
            height: scale(28),
            borderRadius: scale(14),
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: C('Background/Light/Panel'),
          }}
        >
          <Icon icon={node.icon} width={scale(15)} height={scale(15)} color={config.accentColor} />
        </View>
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text numberOfLines={1} style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
            {node.eyebrow}
          </Text>
          <Text numberOfLines={2} style={[font['Subhead 2'], { color: C('Label/Light/Primary'), marginTop: scale(1) }]}>
            {node.title}
          </Text>
        </View>
      </View>

      {!!node.subtitle && (
        <Text numberOfLines={2} style={[font.Footnote, { color: C('Label/Light/Secondary') }]}>
          {node.subtitle}
        </Text>
      )}
    </>
  );
};
